<template>
    <div class="box-shadow-inside box-background box-ssjc mt20">
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">助贷业务</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <el-carousel :interval="10000" direction="vertical" height="246px">
            <el-carousel-item>
                <div class="business">
                    <div class="businessItem">
                        <div class="businessItemName">
                            客户数
                        </div>
                        <div class="businessItemNumber">
                            <span>{{variables.CustomersForLender||0}}</span>位
                        </div>
                    </div>
                    <div class="businessItem">
                        <div class="businessItemName">
                            累计签约
                        </div>
                        <div class="businessItemNumber">
                            <span>{{variables.FinancingCountsForLender||0}}</span>笔
                        </div>
                    </div>
                    <div class="businessItem">
                        <div class="businessItemName">
                            累计放款
                        </div>
                        <div class="businessItemNumber">
                            <span>{{ Math.round( (Number(variables.FinancingValuesForLender)||0)/10000 )}}</span>万元
                        </div>
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="business">
                    <div class="businessItem">
                        <div class="businessItemName">
                            进件数
                        </div>
                        <div class="businessItemNumber">
                            <span>{{variables.ApplicationsForLender||0}}</span>笔
                        </div>
                    </div>
                    <div class="businessItem">
                        <div class="businessItemName">
                            在途签约
                        </div>
                        <div class="businessItemNumber">
                            <span>{{variables.ActiveFinancingCountsForLender||0}}</span>笔
                        </div>
                    </div>
                    <div class="businessItem">
                        <div class="businessItemName">
                            实时余额
                        </div>
                        <div class="businessItemNumber">
                            <span>{{ Math.round( (Number(variables.ActiveFinancingValuesForLender)||0) /10000)}}</span>万元
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>

    export default {
        name: 'MonitorLeftOneself',
        data() {
            return {
                nowDate: "",
            }
        },
        computed: {

        },
        mounted() {
        },
        components: {

        },
        props: {
            variables: {
                type: Object
            }
        },
        beforeDestroy() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorLeftOther.vue